module.exports = __webpack_public_path__ + "static/media/silence_25s.61a46325.mp3";